import React from "react";
import { motion } from "framer-motion";
import "./Skills.css";

const SKILL_GROUPS = [
  {
    label: "Languages",
    items: [
      { name: "Python", icon: "logos:python" },
      { name: "C#", icon: "devicon:csharp" },
      { name: "TypeScript", icon: "vscode-icons:file-type-typescript-official" },
      { name: "JavaScript", icon: "vscode-icons:file-type-js-official" },
      { name: "Terraform", icon: "logos:terraform-icon" },
      { name: "C", icon: "logos:c" },
      { name: "C++", icon: "devicon:cplusplus" },
      { name: "SQL", icon: "vscode-icons:file-type-sql" },
      { name: "Bash", icon: "logos:bash-icon" },
      { name: "x86 Assembly", icon: "mdi:chip" },
      { name: "HTML", icon: "skill-icons:html" },
      { name: "CSS", icon: "vscode-icons:file-type-css" },
    ],
  },
  {
    label: "Frameworks",
    items: [
      { name: ".NET Core", icon: "logos:dotnet" },
      { name: "React", icon: "logos:react" },
      { name: "Node.js", icon: "logos:nodejs-icon" },
      { name: "FastAPI", icon: "simple-icons:fastapi" },
      { name: "Django", icon: "vscode-icons:file-type-django" },
      { name: "Redux", icon: "logos:redux" },
    ],
  },
  {
    label: "Infrastructure",
    items: [
      { name: "Linux", icon: "flat-color-icons:linux" },
      { name: "Docker", icon: "logos:docker-icon" },
      { name: "Kubernetes", icon: "logos:kubernetes" },
      { name: "AWS", icon: "logos:aws" },
      { name: "Terraform", icon: "logos:terraform-icon" },
      { name: "GitHub Actions", icon: "logos:github-actions" },
      { name: "Bamboo", icon: "simple-icons:bamboo" },
    ],
  },
  {
    label: "Data & Messaging",
    items: [
      { name: "PostgreSQL", icon: "logos:postgresql" },
      { name: "MS SQL Server", icon: "devicon:microsoftsqlserver-wordmark" },
      { name: "MongoDB", icon: "vscode-icons:file-type-mongo" },
      { name: "Confluent Kafka", icon: "skill-icons:kafka" },
      { name: "IBM MQ", icon: "simple-icons:ibm" },
      { name: "REST APIs", icon: "tabler:api" },
    ],
  },
  {
    label: "AI Tooling",
    items: [
      { name: "Claude Code", icon: "simple-icons:anthropic" },
      { name: "Claude CLI", icon: "tabler:terminal-2" },
      { name: "Claude APIs", icon: "mdi:api" },
      { name: "GitHub Copilot", icon: "simple-icons:githubcopilot" },
      { name: "Copilot CLI", icon: "tabler:terminal" },
      { name: "Prompt Engineering", icon: "lucide:sparkles" },
      { name: "Agentic Dev", icon: "lucide:bot" },
    ],
  },
];

// Flat export for ChatBot consumption
export const skillsList = SKILL_GROUPS.flatMap((g) => g.items);

const Skills = () => {
  return (
    <section id="skills">
      <motion.div
        className="section-heading"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.4 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      >
        <span className="eyebrow">04 — Skills</span>
        <h2 className="display">
          Tools of <em>the trade.</em>
        </h2>
      </motion.div>

      <div className="skills-groups">
        {SKILL_GROUPS.map((group, gi) => (
          <motion.div
            key={group.label}
            className="skill-group"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{
              duration: 0.5,
              delay: gi * 0.05,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            <div className="skill-group-label">
              <span className="skill-group-num">
                {String(gi + 1).padStart(2, "0")}
              </span>
              <span className="skill-group-name">{group.label}</span>
              <span className="skill-group-line" />
            </div>
            <motion.ul
              className="skill-grid"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.15 }}
              variants={{
                hidden: {},
                visible: { transition: { staggerChildren: 0.03 } },
              }}
            >
              {group.items.map((skill) => (
                <motion.li
                  key={skill.name}
                  className="skill-chip"
                  variants={{
                    hidden: { opacity: 0, y: 16 },
                    visible: {
                      opacity: 1,
                      y: 0,
                      transition: { type: "spring", stiffness: 240, damping: 20 },
                    },
                  }}
                  whileHover={{ y: -4 }}
                >
                  <iconify-icon
                    className="skill-icon"
                    icon={skill.icon}
                  ></iconify-icon>
                  <span className="skill-name">{skill.name}</span>
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
